import { type Company, useCompany } from 'modules/app/hooks/useCompany';
import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { CompanyInformationFormContainer } from './components/CompanyInformationForm';

const isInformationEditDisabled = (company: Company) => {
  return (
    company.currency !== 'GBP' &&
    ['initial', 'branch_entity'].includes(company.type)
  );
};

export const CompanyInformationPage = () => {
  const { t } = useTranslation('global');
  const company = useCompany();

  return (
    <section
      aria-labelledby="companyInformation"
      className="GeneralSettings__section"
    >
      <h1 id="companyInformation" className="text-completementary heading-l">
        {t('generalSettings.companyInformation.title')}
      </h1>
      <p className="text-content-secondary-bg-primary body-m mt-8">
        {t('generalSettings.companyInformation.description')}
      </p>
      <CompanyInformationFormContainer
        disabled={isInformationEditDisabled(company)}
        companyInformation={{
          address: company.address,
          address2: company.address2,
          city: company.city,
          country: company.country,
          name: company.name,
          zipcode: company.zipcode,
        }}
      />
    </section>
  );
};
